import React from 'react';

import { Logo } from './Logo';
import { MenuGroup } from '../components/MenuGroup';

type MenuProps = {
  routes: Array<AppRouteType>;
  externals?: Array<AppRouteType>;
};

export const Menu: React.FC<MenuProps> = ({ routes, externals }) => {
  return (
    <div className="flex flex-col items-start justify-start p-xl pr-0 min-h-full">
      <Logo />
      <MenuGroup items={routes} />
      {!!externals?.length && (
        <>
          <div className="mt-auto" data-what="separator" />
          <MenuGroup items={externals} />
        </>
      )}
    </div>
  );
};
